<h3 class="title">{{ "import.title" | translate }}</h3>
<h4 class="subtitle">{{ "import.subtitle" | translate }}</h4>

<p>{{ "import.text" | translate }}</p>

@if (uploadResponse) {
<div
  class="alert"
  [class.alert-success]="uploadResponse.success"
  [class.alert-danger]="!uploadResponse.success"
>
  {{ uploadResponse.message }}
</div>
}

<div class="d-flex flex-column align-items-center gap-2 w-100">
  <p-fileUpload
    [showUploadButton]="false"
    [showCancelButton]="false"
    [chooseLabel]="file ? file.name : ('import.selectFile' | translate)"
    [multiple]="false"
    accept=".xlsx,.xls"
    maxFileSize="10000000"
    (onSelect)="onSelect($event)"
    (onRemove)="removeFile()"
    (onInvalidFileSelect)="onInvalidFile()"
    [style]="{ width: '100%' }"
    class="w-100"
  >
    <ng-template pTemplate="content">
      <div class="upload d-flex flex-column align-items-center w-100">
        <i
          class="bi"
          [ngClass]="{
            'bi-box-arrow-in-up': !file,
            'bi-file-earmark-spreadsheet': file
          }"
          class="display-1"
        ></i>
        <p *ngIf="!file">
          {{ "import.dragAndDrop" | translate }}
        </p>
        <div *ngIf="file" class="flex flex-column align-items-center gap-2">
          <p>{{ "import.fileSelected" | translate }} : {{ file.name }}</p>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>

  @if (uploading) {
  <p-progressBar
    *ngIf="uploading"
    mode="indeterminate"
    [style]="{ width: '200px' }"
  ></p-progressBar>
  } @if (file && !uploading) {

  <button
    (click)="sendFile()"
    [style]="{ width: '200px' }"
    class="btn btn-success text-uppercase align-self-center"
  >
    <em class="pi pi-upload"></em> {{ "import.sendFile" | translate }}
  </button>
  }
</div>
